"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MunicipalitySelection = void 0;
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var withMName_1 = require("../../utils/withMName");
var underscore_1 = __importDefault(require("underscore"));
var Backbone = __importStar(require("backbone"));
var grouping_1 = require("../../grouping");
var MunicipalitySelection = /** @class */ (function (_super) {
    __extends(MunicipalitySelection, _super);
    function MunicipalitySelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MunicipalitySelection.prototype.events = function () {
        return {
            'click .js-prompt': this.onClickPrompt.mname,
            'click .js-selected': this.onRemoveMunicipality.mname,
            'click .js-suggestion': this.onAddSuggestion.mname,
            'click .js-clear-all': this.onClearAll.mname,
            'click .js-municipality-group': this.onChangeGroup.mname,
            'suggestion:clicked .js-auto-complete': this.onFormSubmit.mname,
            'submit form': this.onFormSubmit.mname
        };
    };
    MunicipalitySelection.prototype.initialize = function () {
        var _this = this;
        underscore_1.default.bindAll(this, this.onFormSubmit.mname, this.onClearAll.mname, this.onClickPrompt.mname, this.onRemoveMunicipality.mname, this.onChangeGroup.mname, this.onAddSuggestion.mname);
        this.suggestions = [];
        this.showTop = false;
        this.model.bind('change', this.render, this);
        this.model.bind('change:top', this.onTopChanged, this);
        $(document).on('click', function () {
            return _this.$el.find('.js-options').hide();
        });
        return this.$el.on('click', function (e) { return e.stopPropagation(); });
    };
    MunicipalitySelection.prototype.render = function () {
        var _a;
        var selected = this.model.get('compareTo');
        var shown = underscore_1.default.uniq(((_a = this.suggestions) !== null && _a !== void 0 ? _a : []).concat(selected));
        selected.sort();
        shown.sort();
        var municipalities = shown.map(function (name) { return ({ name: name, selected: underscore_1.default.includes(selected, name) }); });
        this.$el.find('.js-selected').html(MunicipalitySelection.selectedTemplate({ municipalities: municipalities }));
        return this;
    };
    MunicipalitySelection.prototype.toggleOptions = function () {
        var options = this.$el.find('.js-options');
        var prompt = this.$el.find('.js-prompt');
        if (options.is(':visible')) {
            options.hide();
            return prompt.removeClass('expanded');
        }
        else {
            options.show();
            return prompt.toggleClass('expanded');
        }
    };
    MunicipalitySelection.prototype.onClickPrompt = function (e) {
        e.stopPropagation();
        e.preventDefault();
        return this.toggleOptions();
    };
    MunicipalitySelection.prototype.onRemoveMunicipality = function (e) {
        e.preventDefault();
        e.stopPropagation();
        return this.model.removeMunicipality($(e.target).data('municipality'));
    };
    MunicipalitySelection.prototype.onAddSuggestion = function (e) {
        e.preventDefault();
        e.stopPropagation();
        return this.model.addMunicipality($(e.target).data('municipality'));
    };
    MunicipalitySelection.prototype.onFormSubmit = function (e) {
        e.preventDefault();
        var field = this.$el.find(':text');
        var muni = field.val();
        if (typeof muni === 'string') {
            this.model.addMunicipality(muni);
        }
        return field.val('');
    };
    MunicipalitySelection.prototype.onClearAll = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.suggestions = [];
        this.showTop = false;
        this.model.set('compareTo', []);
        return this.render();
    };
    MunicipalitySelection.prototype.onChangeGroup = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var group = $(e.target).data('group');
        if (group === 'top') {
            this.showTop = true;
            return this.displaySuggestions(underscore_1.default.pluck(this.model.top(), 'name'));
        }
        else {
            this.showTop = false;
            var municipality = this.model.get('municipality');
            return this.displaySuggestions(grouping_1.Grouping.forMunicipality(municipality, group));
        }
    };
    MunicipalitySelection.prototype.onTopChanged = function () {
        if (this.showTop) {
            this.displaySuggestions(underscore_1.default.pluck(this.model.top(), 'name'));
        }
    };
    MunicipalitySelection.prototype.displaySuggestions = function (suggestions) {
        var municipality = this.model.get('municipality');
        this.suggestions = underscore_1.default.without(suggestions, municipality);
        this.suggestions.sort();
        return this.render();
    };
    MunicipalitySelection.selectedTemplate = underscore_1.default.template("\n        <% for (var i = 0; i < municipalities.length; i++) { %>\n          <% if (municipalities[i].selected) { %>\n            <li><a href=\"#\" data-municipality=\"<%= municipalities[i].name %>\" class=\"js-selected\"><%= municipalities[i].name %></a></li>\n          <% } else { %>\n            <li><a href=\"#\" data-municipality=\"<%= municipalities[i].name %>\" class=\"js-suggestion suggestion\"><%= municipalities[i].name %></a></li>\n          <% } %>\n        <% } %>");
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onClickPrompt", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onRemoveMunicipality", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onAddSuggestion", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onFormSubmit", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onClearAll", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onChangeGroup", null);
    __decorate([
        withMName_1.withMName
    ], MunicipalitySelection.prototype, "onTopChanged", null);
    return MunicipalitySelection;
}(Backbone.View));
exports.MunicipalitySelection = MunicipalitySelection;
